// extracted by mini-css-extract-plugin
export var clauseRow = "_aw-6";
export var emptyState = "_aw-b";
export var filterContent = "_aw-a";
export var filterGroup = "_aw-1";
export var filterGroupContainer = "_aw-0";
export var nestedGroup = "_aw-2";
export var nestedGroupDepth1 = "_aw-3";
export var nestedGroupDepth2 = "_aw-4";
export var nestedGroupDepth3 = "_aw-5";
export var operatorAnd = "_aw-8";
export var operatorOr = "_aw-9";
export var operatorToggle = "_aw-7";
export var removeGroupButton = "_aw-c";